<template>
  <div class="main-back d-flex">


    <div class="main-content flex-grow-1">

      <AdminHeader />

      <!-- محتوای صفحه -->
      <div class="page-wrapper">

        <div class="page-card">

             <slot />

   <AppAlert
  :show="alertStore.show"
  :type="alertStore.type"
  :title="alertStore.title"
  :message="alertStore.message"
  @close="alertStore.close()"
/>

    <GlobalLoading />


        </div>

      </div>

    </div>

  </div>
</template>

<script setup>
import AdminHeader from "@/components/AdminHeader.vue";
import AppAlert from "@/components/alerts/AppAlert.vue";
import { alertStore } from "@/stores/alertStore"
import GlobalLoading from "@/components/GlobalLoading.vue";


</script>

<style>

</style>